<div class="forgot-container text-left">
  <a id="how-to-find-reg" href="javascript:void(0)" (click)="whereRegistryNumber()" class="title link">
    Saiba onde encontrar seu número de matrícula
  </a>
</div>
